import { useTranslation } from '@crehana/i18n';
import locales, { ATS_PUBLIC_CAREER_SITE, type TKeys } from '.';

export const useAddResourceBundle = () => {
  const { addResourceBundle } = useTranslation<TKeys>(ATS_PUBLIC_CAREER_SITE);
  addResourceBundle(locales);
};
